import { render, staticRenderFns } from "./normas-vacaciones.vue?vue&type=template&id=65b0f244&scoped=true"
import script from "./normas-vacaciones.vue?vue&type=script&lang=js"
export * from "./normas-vacaciones.vue?vue&type=script&lang=js"
import style0 from "./normas-vacaciones.vue?vue&type=style&index=0&id=65b0f244&prod&scoped=true&lang=css"
import style1 from "./normas-vacaciones.vue?vue&type=style&index=1&id=65b0f244&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b0f244",
  null
  
)

export default component.exports